// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Gy0h","form":"styles_form__3-CS4","submit":"styles_submit__3JhaX","logocontainer":"styles_logocontainer__3VTfj"};